import Alpine from 'alpinejs'

Alpine.data('cookieConsent', () => ({
    
    // config
    
    categoryCodes: {
        analytics: [
            'google_analytics',
            'content_square',
            'hotjar',
        ], 
        marketing: [
            'facebook',
            'pinterest',
            'bing',
            'google_adwords',
            'awin',
            'criteo',
            'daisycon',
            'google_remarketing',
            'tradedoubler',
            'taboola',
            'rtb_house',
            'solute',
        ],
    },

    // state
    
    isOpen: true,
    isShowDetails: false,
    consentChoiceAnalytics: false,
    consentChoiceMarketing: false,

    getBotName() {
        if(navigator) {
            if (navigator.webdriver) {
                return 'webdriver'
            }
            if (navigator.userAgent && /headless/i.test(navigator.userAgent)) {
                return 'headless-ua'
            }
            if (navigator.appVersion && /headless/i.test(navigator.appVersion)) {
                return 'headless-app'
            }
        }
        if (window.callPhantom || window._phantom || window.phantom) {
            return 'window-phantom'
        }
        if (document.__selenium_unwrapped || document.__webdriver_evaluate || document.__driver_evaluate) {
            return 'selenium'
        }
        return null
    },
    
    getUrl(action) {
        let url = '/misc_frontend/tracking/'+action
        const botName = this.getBotName()
        if(botName) {
            url += '/b/'+botName
        }
        return url
    },
    
    closeDialog() {
        this.isOpen = false
    },
    
    showDialog() {
        return this.isOpen
    },
    
    openDetails() {
        this.isShowDetails = true
        
        fetch(this.getUrl('consentConfigure'), { method: 'POST' })
    },
    
    showDetails() {
        return this.isShowDetails
    },

    consentAll() {
        this.closeDialog()  
        
        fetch(this.getUrl('consentAll'), { method: 'POST', credentials: 'include' })
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.status === 'ok') {
                    if(typeof window.tr_load_google_analytics === 'function') {
                        window.tr_load_google_analytics()
                    }
                    if(typeof window.tr_load_google_ads === 'function') {
                        window.tr_load_google_ads()
                    }
                    if(typeof window.tr_load_content_square === 'function') {
                        window.tr_load_content_square()
                    }
                    if(typeof window.tr_load_hotjar === 'function') {
                        window.tr_load_hotjar()
                    }
                    if(typeof window.tr_load_rtb_house === 'function') {
                        window.tr_load_rtb_house()
                    }
                    if(typeof window.tr_load_facebook === 'function') {
                        window.tr_load_facebook()
                    }
                    if(typeof window.tr_load_pinterest === 'function') {
                        window.tr_load_pinterest()
                    }
                    if(typeof window.tr_load_criteo === 'function') {
                        window.tr_load_criteo()
                    }
                    if(typeof window.tr_load_solute === 'function') {
                        window.tr_load_solute()
                    }
                }
            })
    },
    
    consentChosen() {
        this.closeDialog()

        const formData = new FormData();
        if(!this.consentChoiceAnalytics) {
            this.categoryCodes.analytics.forEach(serviceCode => formData.append('t[]', serviceCode))
        }
        if(!this.consentChoiceMarketing) {
            this.categoryCodes.marketing.forEach(serviceCode => formData.append('t[]', serviceCode))
        }
        
        fetch(this.getUrl('consentSettings'), { method: 'POST', credentials: 'include', body: formData })
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.status === 'ok') {
                    if(this.consentChoiceAnalytics) { 
                        if(typeof window.tr_load_google_analytics === 'function') {
                            window.tr_load_google_analytics()
                        }
                        if(typeof window.tr_load_content_square === 'function') {
                            window.tr_load_content_square()
                        }
                        if(typeof window.tr_load_hotjar === 'function') {
                            window.tr_load_hotjar()
                        }
                    }
                    if(this.consentChoiceMarketing) { 
                        if(typeof window.tr_load_google_ads === 'function') {
                            window.tr_load_google_ads()
                        }
                        if(typeof window.tr_load_rtb_house === 'function') {
                            window.tr_load_rtb_house()
                        }
                        if(typeof window.tr_load_facebook === 'function') {
                            window.tr_load_facebook()
                        }
                        if(typeof window.tr_load_pinterest === 'function') {
                            window.tr_load_pinterest()
                        }
                        if(typeof window.tr_load_criteo === 'function') {
                            window.tr_load_criteo()
                        }
                        if(typeof window.tr_load_solute === 'function') {
                            window.tr_load_solute()
                        }
                    }
                }
            })
    },

    rejectAll() {
        this.closeDialog()

        fetch(this.getUrl('consentRejectAll'), { method: 'POST', credentials: 'include' })
    },
    
}));